import { Skeleton } from '../../../feedback/Skeleton';
import { Flex, FlexProps } from '../../../layout/Flex';
import { Wrapper } from '../styles';

export const UserSkeleton = (props: FlexProps) => (
    <Wrapper {...props}>
        <Flex direction="row" spacing={2} width="100%" justifyContent="space-between">
            <Flex spacing={2}>
                <Flex direction="row" spacing={2}>
                    <Skeleton variant="circular" width={80} height={80} />
                    <Flex spacing={0.25}>
                        <Skeleton variant="text" width={150} height={35} />
                        <Skeleton variant="text" width={100} height={18} />
                    </Flex>
                </Flex>
                <Skeleton variant="text" width={100} height={24} />
            </Flex>
        </Flex>
    </Wrapper>
);
